export enum OnOffDefaultType {
  On = "On",
  Off = "Off",
  Default = "Default"
}
